// extracted by mini-css-extract-plugin
export default {"list":"Content_list__SRO-w","listItem":"Content_listItem__brcxp"};